import { useSelector, shallowEqual } from 'react-redux';

/**
 * Helper function for wrapping a selector with a shallowEqual equality function
 */
export const useShallowEqualSelector = selector => {
  return useSelector(selector, shallowEqual);
};
